export const PRODUCTS = [
  {
    id: 1,
    articleNumber: "0201",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0201",
    desc: "Utan verksamhetsnamn, Format 75x30mm",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "standard",
    fields: {
      name: true,
      title: { label: "Titel" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 2,
    articleNumber: "0202",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0202",
    desc: "Med verksamhetsnamn, En rad, Format 75x30mm",
    image: "/art.-0202.jpg",
    isImplemented: true,
    group: "standard",
    fields: {
      name: true,
      title: { label: "Titel" },
      orgLine1: { label: "Verksamhetsnamn" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 3,
    articleNumber: "0205",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0205",
    desc: "Utan verksamhetsnamn, med två titlar, Format 75x35mm",
    image: "/art.-0205.jpg",
    isImplemented: true,
    group: "standard",
    fields: {
      name: true,
      title: { label: "Titel rad 1" },
      titleLine2: { label: "Titel rad 2" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 4,
    articleNumber: "0207",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0207",
    desc: "Med verksamhetsnamn, 2 rader, Format 75x30mm",
    image: "/art.-0207.jpg",
    isImplemented: true,
    group: "standard",
    fields: {
      name: true,
      title: { label: "Titel" },
      orgLine1: { label: "Verksamhetsnamn rad 1" },
      orgLine2: { label: "Verksamhetsnamn rad 2" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 208,
    articleNumber: "0208",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0208",
    desc: "Med verksamhetsnamn, en rad, Format 75x26mm",
    image: "/art.-0208.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fields: {
      name: true,
      title: { label: "Titel" },
      orgLine1: { label: "Verksamhetsnamn" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 211,
    articleNumber: "0211",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0211",
    desc: "Energikontor Norra Småland, namn och titel, Format 75x30mm",
    image: "/art.-0211.jpg",
    isImplemented: true,
    group: "energikontor",
    fields: {
      name: true,
      title: { label: "Titel" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 212,
    articleNumber: "0212",
    categoryId: "namnbrickor",
    productType: "namnbricka",
    flowType: "form",
    previewType: "badge",
    name: "Art.nr 0212",
    desc: "Energikontor Norra Småland, namn, titel och verksamhetsnamn, Format 75x30mm",
    image: "/art.-0212.jpg",
    isImplemented: false,
    group: "energikontor",
    fields: {
      name: true,
      title: { label: "Titel" },
      orgLine1: { label: "Verksamhetsnamn" },
      fastening: true,
      quantity: true,
      extraMagnets: true,
    },
    fasteningOptions: ["Magnet", "Plastklämma"],
  },
  {
    id: 50,
    articleNumber: "YRK-0204",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Läkare",
    desc: "Yrkestitelsskylt i röd färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Läkare",
    fixedColor: "Röd",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 51,
    articleNumber: "YRK-0205",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Sjuksköterska",
    desc: "Yrkestitelsskylt i blå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Sjuksköterska",
    fixedColor: "Blå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 52,
    articleNumber: "YRK-0206",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Barnmorska",
    desc: "Yrkestitelsskylt i blå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Barnmorska",
    fixedColor: "Blå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 53,
    articleNumber: "YRK-0207",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Undersköterska",
    desc: "Yrkestitelsskylt i grön färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Undersköterska",
    fixedColor: "Grön",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 67,
    articleNumber: "YRK-0219-3",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Omvårdnadsassistent",
    desc: "Yrkestitelsskylt i grön färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Omvårdnadsassistent",
    fixedColor: "Grön",
    fixedTextColor: "Vit",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 54,
    articleNumber: "YRK-0208",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Fysioterapeut",
    desc: "Yrkestitelsskylt i orange färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Fysioterapeut",
    fixedColor: "Orange",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 55,
    articleNumber: "YRK-0209",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Arbetsterapeut",
    desc: "Yrkestitelsskylt i orange färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Arbetsterapeut",
    fixedColor: "Orange",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 56,
    articleNumber: "YRK-0210",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Vårdadministratör",
    desc: "Yrkestitelsskylt i lila färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Vårdadministratör",
    fixedColor: "Lila",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 57,
    articleNumber: "YRK-0211",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Administrativ samordnare",
    desc: "Yrkestitelsskylt i lila färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Administrativ samordnare",
    fixedColor: "Lila",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 58,
    articleNumber: "YRK-0212",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandläkare",
    desc: "Yrkestitelsskylt i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Tandläkare",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 59,
    articleNumber: "YRK-0213",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandhygienist",
    desc: "Yrkestitelsskylt i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Tandhygienist",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 60,
    articleNumber: "YRK-0214",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandsköterska",
    desc: "Yrkestitelsskylt i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Tandsköterska",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 61,
    articleNumber: "YRK-0215",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Receptionist",
    desc: "Yrkestitelsskylt i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Receptionist",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 62,
    articleNumber: "YRK-0216",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Ortopedassistent",
    desc: "Yrkestitelsskylt i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Ortopedassistent",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 63,
    articleNumber: "YRK-0217",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Biomedicinsk analytiker",
    desc: "Yrkestitelsskylt i vinröd färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Biomedicinsk analytiker",
    fixedColor: "Vinröd",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 64,
    articleNumber: "YRK-0218",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Servicepersonal",
    desc: "Yrkestitelsskylt i svart färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Servicepersonal",
    fixedColor: "Svart",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 65,
    articleNumber: "YRK-0219",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Student",
    desc: "Yrkestitelsskylt i vit färg med svart text.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "Student",
    fixedColor: "Vit",
    fixedTextColor: "Svart",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 66,
    articleNumber: "YRK-0219-2",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "ELEV",
    desc: "Yrkestitelsskylt i vit färg med svart text.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    fixedProfessionTitle: "ELEV",
    fixedColor: "Vit",
    fixedTextColor: "Svart",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },

  {
    id: 220,
    articleNumber: "YRK-FT-0220",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Enhetschef",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Enhetschef",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 221,
    articleNumber: "YRK-FT-0221",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Klinikchef",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Klinikchef",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 222,
    articleNumber: "YRK-FT-0222",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Klinikkoordinator",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Klinikkoordinator",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 223,
    articleNumber: "YRK-FT-0223",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Ortodontiassistent",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Ortodontiassistent",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 224,
    articleNumber: "YRK-FT-0224",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Receptionist",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Receptionist",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 225,
    articleNumber: "YRK-FT-0225",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "ST-tandläkare",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "ST-tandläkare",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 226,
    articleNumber: "YRK-FT-0226",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Specialisttandsköterska",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Specialisttandsköterska",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 227,
    articleNumber: "YRK-FT-0227",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Sterilbiträde",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Sterilbiträde",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 228,
    articleNumber: "YRK-FT-0228",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandhygienist",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Tandhygienist",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 229,
    articleNumber: "YRK-FT-0229",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandläkare",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Tandläkare",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 230,
    articleNumber: "YRK-FT-0230",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Tandsköterska",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Tandsköterska",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 231,
    articleNumber: "YRK-FT-0231",
    categoryId: "yrkestitelsskyltar",
    productType: "yrkestitelsskylt",
    subType: "yrkestitelsskyltar",
    flowType: "direct",
    catalogBehavior: "list",
    previewType: "profession",
    name: "Övertandläkare",
    desc: "Yrkestitelsskylt Folktandvården i ljusblå färg.",
    image: "/art.-0201.jpg",
    isImplemented: true,
    group: "folktandvarden",
    fixedProfessionTitle: "Övertandläkare",
    fixedColor: "Ljusblå",
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },

  {
    id: 101,
    articleNumber: "0101",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0101",
    desc: "Dekal runt dörröppnare. Symbol uppe och pil vänster. Format 180x440mm",
    image: "/art.-0101.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 102,
    articleNumber: "0102",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0102",
    desc: "Dekal runt dörröppnare. Symbol uppe och pil höger. Format 180x440mm",
    image: "/art.-0102.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 103,
    articleNumber: "0103",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0103",
    desc: "Dekal runt dörröppnare. Symbol nere och pil vänster. Format 180x440mm",
    image: "/art.-0103.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 104,
    articleNumber: "0104",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0104",
    desc: "Dekal runt dörröppnare. Symbol nere och pil höger. Format 180x440mm",
    image: "/art.-0104.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 105,
    articleNumber: "0105",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    imageVariant: "small",
    name: "Art.nr 0105",
    desc: "Dekal runt dörröppnare. Symbol och pil vänster. Format 440x180mm",
    image: "/art.-0105.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 106,
    articleNumber: "0106",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    imageVariant: "small",
    name: "Art.nr 0106",
    desc: "Dekal runt dörröppnare. Symbol och pil höger. Format 440x180mm",
    image: "/art.-0106.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 107,
    articleNumber: "0107",
    categoryId: "dorroppnare",
    productType: "dorropnare",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0107",
    desc: "Dekal runt dörröppnare. Utan symbol. Format 180x335mm",
    image: "/art.-0107.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 502,
    articleNumber: "0502",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0502",
    desc: "Format 152x156,25mm",
    image: "/art.-0502.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 503,
    articleNumber: "0503",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0503",
    desc: "Format 152x156,25mm",
    image: "/art.-0503.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 504,
    articleNumber: "0504",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0504",
    desc: "Format 152x156,25mm",
    image: "/art.-0504.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 506,
    articleNumber: "0506",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0506",
    desc: "Format 152x156,25mm",
    image: "/art.-0506.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 508,
    articleNumber: "0508",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0508",
    desc: "Format 152x156,25mm",
    image: "/art.-0508.jpg",
    isImplemented: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 505,
    articleNumber: "0505",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0505",
    desc: "Format 152x312,5mm",
    image: "/art.-0505.jpg",
    isImplemented: true,
    fields: {
      quantity: { type: "number", label: "Antal", min: 1 },
      customText: {
        type: "text",
        label: "Dubbelskylt, ange vilka 2 symboler som ska kombineras",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
    },
    fasteningOptions: [],
  },
  {
    id: 507,
    articleNumber: "0507",
    categoryId: "taktila-piktogram",
    productType: "taktila_piktogram",
    productTypeLabel: "Taktila piktogram",
    flowType: "direct",
    previewType: "image",
    name: "Art.nr 0507",
    desc: "Format 152x156,25mm",
    image: "/art.-0507.jpg",
    isImplemented: true,
    fields: {
      quantity: { type: "number", label: "Antal", min: 1 },
      customText: {
        type: "text",
        label: "Text",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
    },
    fasteningOptions: [],
  },
  {
    id: 601,
    articleNumber: "0601",
    categoryId: "dorrskyltar",
    productType: "dorrskylt",
    productTypeLabel: "Dörrskylt",
    flowType: "form",
    previewType: "door_sign",
    name: "Art.nr 0601",
    desc: "Taktil rumsfunktionsskylt. Format 192x93,75mm",
    image: "/art.-0601.jpg",
    isImplemented: true,
    fields: {
      customText: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 1",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 2",
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 602,
    articleNumber: "0602",
    categoryId: "dorrskyltar",
    productType: "dorrskylt",
    productTypeLabel: "Dörrskylt",
    flowType: "form",
    previewType: "door_sign",
    name: "Art.nr 0602",
    desc: "Rumsfunktionsskylt med pappersutskrift. Format 192x93,75mm",
    image: "/art.-0602.jpg",
    isImplemented: true,
    fields: {
      customText: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 1",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 2",
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 614,
    articleNumber: "0614",
    categoryId: "dorrskyltar",
    productType: "dorrskylt",
    productTypeLabel: "Dörrskylt",
    flowType: "form",
    previewType: "image",
    name: "0614",
    desc: "Rumsskylt med skjutbar lucka",
    extraLine: "Text: SMITTA",
    format: "192x93,75mm",
    image: "/art.-0614.jpg",
    isImplemented: true,
    directAddToCart: true,
    fields: {
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 301,
    articleNumber: "0301",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    productTypeLabel: "Pendlad skylt",
    flowType: "form",
    previewType: "hanging_sign",
    name: "Pendlad skylt - vit bakgrund, enkelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1500x140mm",
    image: "/pendlad-vit.png",
    isImplemented: true,
    fields: {
      customText: {
        label: "Text",
      },
      arrowPlacement: {
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        label: "Pilriktning",
        options: [
          { value: "left", label: "Vänster" },
          { value: "right", label: "Höger" },
          { value: "up", label: "Upp" },
          { value: "down", label: "Ner" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 302,
    articleNumber: "0302",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    name: "Pendlad skylt - vit bakgrund, dubbelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1500x140mm",
    image: "/pendlad-vit.png",
    isImplemented: true,
    fields: {
      customText: {
        type: "text",
        label: "Text",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 303,
    articleNumber: "0303",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    productTypeLabel: "Pendlad skylt",
    flowType: "form",
    previewType: "hanging_sign",
    imageVariant: "small",
    name: "Pendlad skylt - vit bakgrund, enkelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1000x93mm",
    image: "/pendlad-vit-liten.png",
    isImplemented: true,
    fields: {
      customText: {
        label: "Text",
      },
      arrowPlacement: {
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        label: "Pilriktning",
        options: [
          { value: "left", label: "Vänster" },
          { value: "right", label: "Höger" },
          { value: "up", label: "Upp" },
          { value: "down", label: "Ner" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 304,
    articleNumber: "0304",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    imageVariant: "small",
    name: "Pendlad skylt - vit bakgrund, dubbelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1000x93mm",
    image: "/pendlad-vit-liten.png",
    isImplemented: true,
    fields: {
      customText: {
        type: "text",
        label: "Text",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 305,
    articleNumber: "0305",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    hangingSignTextMode: "double",
    name: "Pendlad skylt - vit bakgrund, enkelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1500x260mm",
    image: "/pendlad-vit-stor.png",
    isImplemented: true,
    fields: {
      customTextLine1: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 306,
    articleNumber: "0306",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    hangingSignTextMode: "double",
    name: "Pendlad skylt - vit bakgrund, dubbelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil. Format 1500x260mm",
    image: "/pendlad-vit-stor.png",
    isImplemented: true,
    fields: {
      customTextLine1: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 1",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 2",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 307,
    articleNumber: "0307",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    hangingSignTextMode: "double",
    imageVariant: "small",
    name: "Pendlad skylt - vit bakgrund, enkelsidig",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil . Format 1000x186mm",
    image: "/pendlad-vit-stor.png",
    isImplemented: true,
    fields: {
      customTextLine1: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Text",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
  {
    id: 308,
    articleNumber: "0308",
    categoryId: "pendlade-vit",
    productType: "pendlad_skylt",
    flowType: "form",
    previewType: "hanging_sign",
    hangingSignTextMode: "double",
    name: "Pendlad skylt - vit bakgrund, dubbelsidig",
    imageVariant: "small",
    desc: "Pendlad hänvisnings- eller verksamhetsskylt med eller utan pil. Format 1000x186mm",
    image: "/pendlad-vit-stor.png",
    isImplemented: true,
    fields: {
      customTextLine1: {
        type: "text",
        label: "Textrad 1",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 1",
      },
      customTextLine2: {
        type: "text",
        label: "Textrad 2",
        placeholder: "Skriv text här",
        cartLabel: "Textrad 2",
      },
      arrowPlacement: {
        type: "select",
        label: "Pilplacering",
        options: [
          { value: "none", label: "Ingen pil" },
          { value: "left", label: "Vänster sida" },
          { value: "right", label: "Höger sida" },
        ],
      },
      arrowDirection: {
        type: "select",
        label: "Pilriktning",
        options: [
          { value: "left", label: "← Vänster" },
          { value: "right", label: "→ Höger" },
          { value: "up", label: "↑ Upp" },
          { value: "down", label: "↓ Ned" },
        ],
      },
      quantity: true,
    },
    fasteningOptions: [],
  },
];

export const NAME_BADGE_PRODUCTS = PRODUCTS.filter(
  (product) => product.categoryId === "namnbrickor" && product.isImplemented
);

export function getProductsByCategory(categoryId) {
  return PRODUCTS.filter(
    (product) => product.categoryId === categoryId && product.isImplemented
  );
}

export function getProductById(productId) {
  return PRODUCTS.find((product) => product.id === productId);
}

export function getProductFlowType(product) {
  if (!product) return "form";
  return product.flowType || "form";
}

export function getProductPreviewType(product) {
  if (!product) return "image";
  return product.previewType || "image";
}

export function isDirectFlowProduct(product) {
  return getProductFlowType(product) === "direct";
}

export function isFormFlowProduct(product) {
  return getProductFlowType(product) === "form";
}

export function isProfessionFlowProduct(product) {
  return getProductFlowType(product) === "profession";
}